// extracted by mini-css-extract-plugin
var _1 = "SidebarTopics-module__add--Eafcf";
var _2 = "SidebarTopics-module__addWrapper--m7aLa";
var _3 = "SidebarTopics-module__animatedBackground--JYoR6";
export { _1 as "add", _2 as "addWrapper", _3 as "animatedBackground" }
